import { useCallback } from 'react'
import { hasPermission } from '@nexbit/types'
import { useAuth } from '@/contexts/auth'

/**
 * Whether the signed-in admin may do something, judged by the same function the API
 * uses. Sharing it is the point: a button drawn for an action the server will refuse is
 * a dead end with a 403 at the end of it, and two copies of the rule drift apart the
 * first time a permission moves.
 *
 *   const can = useCan()
 *   {can('draws:settle') && <SettleButton />}
 *
 * This hides affordances; it is not the guard — the server decides. Never rely on it to
 * keep anyone out of anything.
 */
export function useCan(): (key: string) => boolean {
  const { permissions } = useAuth()
  return useCallback((key: string) => hasPermission(permissions, key), [permissions])
}
